module.exports = __webpack_public_path__ + "img/CAPTAIN_BIKE_135_UP_LEFT.c74f26b3.png";